import { shallowEqual, useSelector } from 'react-redux';
import { selectCurrentShow } from '@/state/selectors/audio';

const selector = (state) => ({ currentlyPlayingChannel: selectCurrentShow(state) });

const useCurrentlyPlayingShow = () => {
  const { currentlyPlayingChannel } = useSelector(selector, shallowEqual);

  return currentlyPlayingChannel;
};
    
export default useCurrentlyPlayingShow;